import client from './api-client';

export const getConfiguracionForm = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getEventosBitacora = async(query) => {
    try {
        
        const response = await client.get(`bitacoras?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                eventos: response.data.object,
                query: query
            };
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getConceptos = async(query) => {
    try {
        
        const response = await client.get(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object;
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const postRegistraBitacora = async(bitacora) => {
    try {
        
        const response = await client.post('bitacoras', bitacora);
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object;
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const serviceGetDestinatarios = async (query) => {
    try {
        const response = await client.get(`bitacoras/destinatarios?q=${query}`);
      
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } 
    catch(error){
        throw error;
    }
}
export const serviceGetDetalles = async (query) => {
    try {
        const response = await client.get(`detalles?q=${query}`);
      
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } 
    catch(error){
        throw error;
    }
}